window.jQuery.trumbowyg.langs.pl = {
  viewHTML: 'Pokaż HTML',
  formatting: 'Format',
  p: 'Akapit',
  blockquote: 'Cytat',
  code: 'Kod',
  header: 'Nagłówek',
  bold: 'Pogrubienie',
  italic: 'Pochylenie',
  strikethrough: 'Przekreślenie',
  underline: 'Podkreślenie',
  strong: 'Wytłuszczenie',
  em: 'Uwydatnienie',
  del: 'Usunięte',
  unorderedList: 'Lista nieuporządkowana',
  orderedList: 'Lista uporządkowana',
  insertImage: 'Wstaw obraz z URL',
  insertVideo: 'Wstaw film',
  upload: 'Upload zdjęcia',
  link: 'Link',
  createLink: 'Wstaw link',
  unlink: 'Usuń link',
  justifyLeft: 'Wyrównaj do lewej',
  justifyCenter: 'Wyśrodkuj',
  justifyRight: 'Wyrównaj do prawej',
  justifyFull: 'Wyjustuj',
  horizontalRule: 'Odkreśl linią',
  fullscreen: 'Pełny ekran',
  close: 'Zamknij',
  submit: 'Zastosuj',
  reset: 'Anuluj',
  required: 'Wymagane',
  description: 'Opis',
  title: 'Tytuł',
  text: 'Tekst',
  noembed: 'Film',
};



// WEBPACK FOOTER //
// ./src/translations/trumbowyg.js